<ng-container>
    <h3 mat-dialog-title>
        {{ 'DEVICES.EDIT.TITLE' | transloco }}
        {{ data?.device?.serialNumber }}
        {{ data?.device?.id }}
    </h3>
    <mat-dialog-content>
        <div class="import-wrapper">
            <form [formGroup]="singleForm">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'DEVICES.EDIT.CRANE_ID' | transloco }}</mat-label>
                    <input matInput formControlName="craneId" />
                    <mat-error *ngIf="singleForm.get('craneId')?.hasError('maxlength')">
                        <span class="error-hint">{{ 'DEVICES.EDIT.CRANE_ID_INVALID' | transloco }}</span>
                    </mat-error>
                </mat-form-field>
            </form>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close (click)="onCancel()">{{ 'CLOSE' | transloco }}</button>
        <button mat-flat-button color="primary" [disabled]="singleForm.invalid || singleForm.pristine" (click)="onSubmit()">{{ 'SUBMIT' | transloco }}</button>
    </mat-dialog-actions>
</ng-container>
